import { Region } from "../graphql";

export const regionToWi = (region: Region) => {
  switch (region) {
    case Region.Eu:
      return "eur";
    case Region.Us:
      return "int";
  }
};

export const fromWiRegion = (wiRegion: string) => {
  switch (wiRegion) {
    case "eur":
      return Region.Eu;
    case "int":
      return Region.Us;
  }
};

export const gamecloudUrlFromRegion = (wiRegion: string) => `/${wiRegion}/gamecloud`;
